class LoadingManager {
  static loadingCounter = 0;

  static show({ sectionId = "", elementId = "" } = {}) {
    let selector;
    if (elementId) {
      selector = `#${elementId} #boxed-loading`;
    } else {
      selector = (sectionId ? `#shopify-section-${sectionId} ` : "") + ".boxed-loading";
    }

    document.querySelectorAll(selector).forEach((indicator) => {
      indicator.style.visibility = "visible";
    });
  }

  static hide({ sectionId = "", elementId = "" } = {}) {
    let selector;
    if (elementId) {
      selector = `#${elementId} #boxed-loading`;
    } else {
      selector = (sectionId ? `#shopify-section-${sectionId} ` : "") + ".boxed-loading";
    }

    document.querySelectorAll(selector).forEach((indicator) => {
      indicator.style.visibility = "hidden";
    });
  }

  static hideAll() {
    document.querySelectorAll(".boxed-loading, #boxed-loading").forEach((loader) => {
      loader.style.visibility = "hidden";
    });
  }

  static showAll() {
    document.querySelectorAll(".boxed-loading, #boxed-loading").forEach((loader) => {
      loader.style.visibility = "visible";
    });
  }

  static fullscreen = {
    show: () => {
      LoadingManager.loadingCounter++;
      const indicator = document.querySelector("div.fullscreen-loading");
      if (indicator) indicator.style.visibility = "visible";
    },
    hide: () => {
      LoadingManager.loadingCounter = Math.max(0, LoadingManager.loadingCounter - 1);
      const indicator = document.querySelector("div.fullscreen-loading");
      if (indicator && LoadingManager.loadingCounter === 0) {
        indicator.style.visibility = "hidden";
      }
    },
  };
}
